import { render } from "./Navigation_UserContent.vue?vue&type=template&id=6b896976"
import script from "./Navigation_UserContent.vue?vue&type=script&lang=js"
export * from "./Navigation_UserContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__